import { createTheme } from "@mui/material/styles"

export const theme = createTheme({
    palette: {
        primary: {
            main: "#006298",
        },
        secondary: {
            main: "#71b2c9",
        },
        background: {
            default: "#fafafa",
        },
    },
})

export type ButtonVariant = "text" | "outlined" | "contained"
